import 'core-js/features/array/find';
import 'core-js/es/math/trunc';
import CIResponsive from './ci.service';
import './ci.styles.css';

window.CIResponsive = CIResponsive;